import { TOP_MODEL_OPTIONS } from '../../../data/modalModelOptions'
import StepShell, { Question, Hint, Summary } from '../StepShell'
import Field from '../Field'
import ModelLogo from '../../models/ModelLogo'

export default function StepModel({ answers, dispatch, active }) {
  const selected = answers.model

  function toggle(name) {
    const next = selected.includes(name)
      ? selected.filter((m) => m !== name)
      : [...selected, name]
    dispatch({ type: 'SET_ANSWER', field: 'model', value: next })
  }

  return (
    <StepShell active={active} step={0}>
      <Question>Here's what you configured.</Question>
      <Hint>Pick one or more models &mdash; everything else is guaranteed, not adjustable.</Hint>
      <Field label="Models">
        <div className="mt-1.5 grid grid-cols-1 gap-2.5">
          {TOP_MODEL_OPTIONS.map(({ name, maker, comingSoon }) => {
            const isSelected = selected.includes(name)
            return (
              <button
                key={name}
                type="button"
                aria-pressed={isSelected}
                onClick={() => toggle(name)}
                className={`flex items-center gap-2.5 rounded-[10px] border-[1.5px] px-[15px] py-[13px] text-left font-[inherit] text-[14.5px] transition-colors duration-150 ${
                  isSelected
                    ? 'border-[var(--ink-blue)] bg-[rgba(27,68,224,.04)] font-medium text-[var(--ink)]'
                    : 'border-[var(--line)] bg-white text-[var(--ink-2)] hover:border-[var(--line-2)]'
                }`}
              >
                <ModelLogo maker={maker} />
                <span className="flex-1">{name}</span>
                {comingSoon && (
                  <span className="rounded-full bg-[var(--paper-2)] px-2 py-0.5 font-mono text-[10.5px] tracking-[0.04em] text-[var(--faint)] uppercase">
                    Coming soon
                  </span>
                )}
                {isSelected && <span className="text-[var(--ink-blue)]">&#10003;</span>}
              </button>
            )
          })}
        </div>
      </Field>
      <Summary>
        Model{selected.length === 1 ? '' : 's'}: <b>{selected.length ? selected.join(', ') : 'None selected'}</b><br />
        Rate: <b>{answers.rate}</b><br />
        Guaranteed: <b>Unlimited tokens &middot; Unlimited context &middot; Data privacy &amp; security</b>
      </Summary>
    </StepShell>
  )
}
